import axios from "axios";

const abortController = new AbortController();
const signal = abortController.signal;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL_PROD,
  timeout: process.env.REACT_APP_API_TIMEOUT,
});

export default axiosInstance;
export { abortController, signal };
